// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__9I+U2","container":"Dashboard_container__XuZYm","title":"Dashboard_title__xMOgQ","list":"Dashboard_list__ri4sX"};